import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SavedDialogComponent } from './components/saved-dialog/saved-dialog.component';
import { MaterialModule } from 'src/app/shared/modules/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { DialogModule } from 'src/app/shared/components/dialog/dialog.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [SavedDialogComponent],
  exports: [SavedDialogComponent],
  imports: [CommonModule, RouterModule, MaterialModule, DialogModule, SharedModule]
})
export class SavedModule {}
